import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseTagLockedMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface TagLockedParams {
	tagId: string;
	isLocked: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

export function useTagLockedMutation({ onSuccess, onError }: UseTagLockedMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ tagId, isLocked, impersonationContext }: TagLockedParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tag/${tagId}/isLocked`,
					queryParams: {
						value: isLocked,
					},
				}),
				'PUT'
			);
		},
		onSuccess,
		onError,
	});
}
